// Import required utils
import { getDocumentElement, getDocumentElements, updateFieldTotal } from '../../Utils/Utils';

/**
 * Run the calculation for the livestock handler.
 * 
 * Calculation shown below  (answer will be in Megalitres)
 * Annual litres/head/year (based on selection) x Number of livestock ÷ 1,000,000.
 * 
 * @param   {HTMLElement}   fieldData
 * @param   {HTMLElement}   megaL 
 * @param   {HTMLElement}   unit 
 * @param   {HTMLElement}   type 
 * @param   {HTMLElement}   sub
 * 
 * @returns {void}
 */
const LivestockDrinkingRequirementCalcHandler = (fieldData, megaL, unit, type, sub) => {
    const Dataset = fieldData.packet[type.value];
    let tertiaryField = null;

    // Ensure the field values are numbers
    const typeVal = Number(type.value);
    const subVal = Number(sub.value);
    const unitVal = Number(unit.value);

    // Run the calculation only if conditions are met
    let runCalc;
    if (!isNaN(typeVal) && !isNaN(subVal) && !isNaN(unitVal) && unitVal != 0) {
        runCalc = true
    }

    // Run it or clear it
    if (runCalc && Dataset.secondaryField && sub.value) {
        tertiaryField = Dataset.secondaryField.find(item => Number(item.value) === Number(sub.value));
        megaL.value = (tertiaryField.tertiaryFieldValue * unit.value) / 1000000;
    } else {
        megaL.value = ""
    }
};

/**
 * Retrieves the needed elements for the calculation.
 * 
 * @param   {string}    id
 * @param   {array}     fieldData 
 * 
 * @returns {void}
 */
export const LivestockDrinkingRequirementCalc = (id, fieldData) => {
    // Set the field selectors
    const LivestockMegalSelector = fieldData[0].selectors.livestockMegal;
    const LivestockUnitSelector = fieldData[0].selectors.livestockUnit;
    const LivestockTypeSelector = fieldData[0].selectors.livestockType;
    const LivestockSubSelector = fieldData[0].selectors.livestockSub;
    const LivestockTotalSelector = fieldData[0].selectors.livestockTotal;
    const LivestockSummaryTotalSelector = fieldData[0].selectors.livestockSummaryTotal;

    // Retrieve all instances of the elements, we will use a loop index value to access
    // the correct fields to run the calculations.
    const LivestockMegalField = getDocumentElements(`#${id} [id^="${LivestockMegalSelector}"]`);
    const LivestockUnitField = getDocumentElements(`#${id} [id^="${LivestockUnitSelector}"]`);
    const LivestockTypeField = getDocumentElements(`#${id} [id^="${LivestockTypeSelector}"]`);
    const LivestockSubField = getDocumentElements(`#${id} [id^="${LivestockSubSelector}"]`);
    const LivestockTotalField = getDocumentElement(`#${id} ${LivestockTotalSelector}`);
    const LivestockSummaryTotalField = getDocumentElement(LivestockSummaryTotalSelector);
    const FieldsToWatch = [LivestockTypeField, LivestockSubField, LivestockMegalField, LivestockUnitField];

    // We want to attach the keyup event listener to the unit field
    if (LivestockTotalField && LivestockSummaryTotalField) {
        FieldsToWatch.forEach((fields) => {
            fields.forEach((field, i) => {
                field.addEventListener('input', e => {
                    // Use setTimeout, 0 to run calculation on next tick (after CreateCorrespondingValueFields has run)
                    setTimeout(() => {
                        e.stopImmediatePropagation();

                        // Use the variable i to map to the correct related fields.
                        LivestockDrinkingRequirementCalcHandler(
                            fieldData[0],
                            LivestockMegalField[i],
                            LivestockUnitField[i],
                            LivestockTypeField[i],
                            LivestockSubField[i]
                        );

                        updateFieldTotal(LivestockMegalField, LivestockTotalField, LivestockSummaryTotalField);
                    });
                }, 0)
            });
        });

        // listen for clone removed and re-update totals
        document.addEventListener('clonable:removed', e => {
            if (e.detail.id === 'livestock') {
                updateFieldTotal(LivestockMegalField, LivestockTotalField, LivestockSummaryTotalField);
            }
        });
    }
};
